<template>
  <div>
    <b-row>
      <b-col cols="12">
        <sales-filter-card />
      </b-col>
      <b-col
        cols="12"
        md="6"
      >
        <tre-ratio-card
          title="Citroen Satış Adedi"
          :insurance-value="getRandomValue(100)"
          :traffic-value="getRandomValue(100)"
          :value="getRandomValue(1000)"
          :rate="[getRandomValue(100)]"
          rate-title="Poliçe Oranı"
        />
      </b-col>
      <b-col
        cols="12"
        md="6"
      >
        <tre-ratio-card
          title="Honda Satış Adedi"
          :insurance-value="getRandomValue(100)"
          :traffic-value="getRandomValue(100)"
          :value="getRandomValue(1000)"
          :rate="[getRandomValue(100)]"
          rate-title="Poliçe Oranı"
        />
      </b-col>
      <b-col
        cols="12"
        md="6"
      >
        <tre-ratio-card
          title="Hyundai Satış Adedi"
          :insurance-value="getRandomValue(100)"
          :traffic-value="getRandomValue(100)"
          :value="getRandomValue(1000)"
          :rate="[getRandomValue(100)]"
          rate-title="Poliçe Oranı"
        />
      </b-col>
      <b-col
        cols="12"
        md="6"
      >
        <tre-ratio-card
          title="Kia Satış Adedi"
          :insurance-value="getRandomValue(100)"
          :traffic-value="getRandomValue(100)"
          :value="getRandomValue(1000)"
          :rate="[getRandomValue(100)]"
          rate-title="Poliçe Oranı"
        />
      </b-col>
      <b-col
        cols="12"
        md="6"
      >
        <tre-ratio-card
          title="Mitsubishi Satış Adedi"
          :insurance-value="getRandomValue(100)"
          :traffic-value="getRandomValue(100)"
          :value="getRandomValue(1000)"
          :rate="[getRandomValue(100)]"
          rate-title="Poliçe Oranı"
        />
      </b-col>
      <b-col
        cols="12"
        md="6"
      >
        <tre-ratio-card
          title="Chery Satış Adedi"
          :insurance-value="getRandomValue(100)"
          :traffic-value="getRandomValue(100)"
          :value="getRandomValue(1000)"
          :rate="[getRandomValue(100)]"
          rate-title="Poliçe Oranı"
        />
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { BRow, BCol } from 'bootstrap-vue'
import SalesFilterCard from '@/views/Sales/Components/FilterCard.vue'
import TreRatioCard from '@/layouts/components/ReportCards/TreRatioCard.vue'

export default {
  name: 'InsuranceSales',
  components: {
    TreRatioCard,
    SalesFilterCard,
    BRow,
    BCol,
  },
  methods: {
    getRandomValue(max) {
      return Math.floor(Math.random() * max)
    },
  },
}
</script>
